import React from "react";
import './RouterErrorComponent.css';
import { Link } from "react-router-dom";

const RouterErrorComponent = () => {
    return (
        <div className="error-component">
            <h1 className="large-text">404</h1>
            <h2>La página que está buscando no existe, favor de regresar al inicio</h2>
            <Link to={'/'}>
                <button className="btn btn-custom">Inicio</button>
            </Link>
        </div>
    );
}

export default RouterErrorComponent;